import React, { useEffect, useState } from "react";
import SiteFeasibility from "./SiteFeasibility/SiteFeasibility";
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Input,
  InputGroup,
  InputRightElement,
  useToast,
  useDisclosure,
} from "@chakra-ui/react";
import * as Unicons from "@iconscout/react-unicons";
import ThreeDRender from "./3DRender/ThreeDRender";
import WatchDemoButton from "../../../../components/WatchDemoButton";
import ConcepMoodBoardForm from "./ConcepMoodBoard/ConcepMoodBoardForm";
import PrimaryButton from "../../../../components/PrimaryButton";
import axios from "axios";
import { getAxiosConfig } from "../../../../utils/helpers";
import Layout from "../../../Layout";
import { useSelector } from "react-redux";
import { useFormContext } from "./FormStateContext";
import { use } from "react";

function Presentation({ isRandom = false }) {
  const { projectData } = useOutletContext() || {};
  const userName = useSelector((state) => state?.userInfo?.userInfo?.fname);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchParams, setSearchParams] = useSearchParams();
  // console.log({user});
  const { activetab, clearAll } = useFormContext();
  const [activeTab, setActiveTab] = useState(() =>
    activetab
      ? activetab
      : {
          showForm: searchParams.get("form") === "true" ? true : false,
          index: Number(searchParams.get("tab")) || 0,
          isEditId: "",
          isRender: false,
        },
  );
  const [presentationData, setPresentationData] = useState([]);
  const [publicLink, setPublicLink] = useState("");
  const [token, setToken] = useState("");
  const [isDuplicating, setIsDuplicating] = useState(false);
  const { pathname } = useLocation();
  // console.log(pathname, "PATHNAME");
  const fetchPresentationData = async () => {
    try {
      if (isRandom) {
        const {
          data: { data },
        } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/random`,
          getAxiosConfig(),
        );
        setPresentationData(data);
      } else {
        const {
          data: { data },
        } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/get-presentation/${projectData?._id}`,
          getAxiosConfig(),
        );
        console.log("PRESENTATION DATA", data);
        setPresentationData((prev) => data);
        {
          const {
            data: { data },
          } = await axios.get(
            `${process.env.REACT_APP_BACK_URL}/api/presentation/get-base/${projectData?._id}`,
            getAxiosConfig(),
          );
          console.log("BASE DATA", data);
          setPresentationData((prev) => {
            return {
              rendered:
                prev.rendered?.length > 0
                  ? prev.rendered.map((v) => {
                      return {
                        ...v,
                        companyLogo: data?.companyLogo,
                        floorMap: data?.floorMap,
                        companyName: data?.companyName,
                        address: data?.address,
                      };
                    })
                  : [],
              feasibility:
                prev.feasibility?.length > 0
                  ? prev.feasibility.map((v) => {
                      return {
                        ...v,
                        companyLogo: data?.companyLogo,
                        siteImage: data?.floorMap,
                        companyName: data?.companyName,
                        address: data?.address,
                      };
                    })
                  : [],
              concept:
                prev.concept?.length > 0
                  ? prev.concept.map((v) => {
                      return {
                        ...v,
                        companyLogo: data?.companyLogo,
                        floorMap: data?.floorMap,
                        companyName: data?.companyName,
                        address: data?.address,
                        designStyle: data?.designStyle,
                      };
                    })
                  : [],
            };
          });
        }
      }
    } catch (error) {
      console.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch presentation data",
      );
    }
  };

  const menuItems = [
    { name: "Site Feasibility", link: "siteFeasibility", isVisible: true },
    {
      name: "Conceptual Mood Board",
      link: "conceptualMoodBoard",
      isVisible: true,
    },
    { name: "3D Render", link: "threeDRender", isVisible: true },
  ];

  const handleTabChange = (index) => {
    clearAll();
    setActiveTab((p) => ({
      ...p,
      showForm: false,
      index: index,
      isEditId: null,
    }));
  };

  // Public view popup functions
  const handleClose = () => {
    onClose();
    setPublicLink("");
  };

  const handlePublicLink = (link) => {
    console.log(link, "PUBLIC LINK");
    setPublicLink(`${process.env.REACT_APP_FRONT_URL}/pv/` + link);
    onOpen();
  };

  async function fetchToken() {
    try {
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/guest-user/${publicLink.split("/")[publicLink.split("/").length - 2]}`,
        getAxiosConfig(),
      );
      setToken(data);
      setPublicLink(publicLink + "?token=" + data);
    } catch (error) {
      console.log("err", error);
      // toast.error('Error in generating public link');
      toast({
        title: "Error generating public link",
        description: "Could not generate the public token.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      handleClose();
    }
  }

  useEffect(() => {
    isRandom ? fetchPresentationData() : projectData && fetchPresentationData();
  }, [projectData?._id, activeTab?.isRender]);

  async function duplicatePresentation(id, type) {
    try {
      setIsDuplicating(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/clone-presentation/${id}`,
        getAxiosConfig({ type }),
      );

      await fetchPresentationData();

      toast({
        title: "Presentation duplicated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } catch (error) {
      console.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to duplicate",
      );
      toast({
        title: "Failed to duplicate",
        description:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } finally {
      setIsDuplicating(false);
    }
  }

  useEffect(() => {
    // return ()=> clearAll();
    if (
      typeof publicLink == "string" &&
      publicLink != "" &&
      !publicLink.includes("token")
    ) {
      fetchToken();
    }
  }, [publicLink]);

  useEffect(() => {
    !window.location.href.includes(
      `?tab=${activeTab.index}&form=${activeTab.showForm}`,
    ) && setSearchParams(`?tab=${activeTab.index}&form=${activeTab.showForm}`);
  }, [activeTab.index, activeTab.showForm]);

  useEffect(() => {
    searchParams.get("tab") &&
      Number(searchParams.get("tab")) !== activeTab.index &&
      setActiveTab((prev) => ({
        ...prev,
        index: Number(searchParams.get("tab")) || 0,
      }));
    searchParams.get("form") &&
      (searchParams.get("form") === "true") !== activeTab.showForm &&
      setActiveTab((prev) => ({
        ...prev,
        showForm: searchParams.get("form") === "true" ? true : false,
      }));
  }, [searchParams.get("tab"), searchParams.get("form")]);

  // console.log("PUBLIC LINK", searchParams.get('tab'),  activeTab.index);
  // console.log("FORM DATA ACTIVE TAB", activeTab, activetab, presentationData);
  return isRandom ? (
    <Layout>
      <div className="mx-auto container p-3">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            {activeTab.showForm && (
              <IconButton
                onClick={() => {
                  clearAll();
                  setActiveTab((prev) => ({
                    ...activeTab,
                    showForm: !prev.showForm,
                    isEditId: null,
                  }));
                }}
                colorScheme="gray"
                size={"sm"}
                icon={<Icon icon={"ion:arrow-back"} color="black" />}
              />
            )}
            {/* <h2 className="text-xl font-bold">{projectData?.title}</h2> */}
            <h2 className="text-xl font-bold">{"Presentation"}</h2>
          </div>
          <div className="flex gap-3">
            {/* <a
              href="https://drive.google.com/file/d/1ZUwsBQxgl7BSMEzWWf4MifWGgHSJIatQ/view?usp=drive_link"
              target="_blank"
            >
              {" "}
              <button className="py-2 text-md px-7 rounded-md bg-[#fff] inline-flex gap-2 items-center text-[#018081] font-medium">
                Watch Demo <Unicons.UilPlay />
              </button>
            </a> */}
            <WatchDemoButton
              videoUrl={
                "https://drive.google.com/file/d/1ZUwsBQxgl7BSMEzWWf4MifWGgHSJIatQ/view"
              }
            />
            {/* <Button className="bg-primary-500 text-white rounded-lg p-3 text-sm flex gap-1 items-center">
            <Icon className="text-lg" icon="fluent:add-48-filled" /> Create New
          </Button> */}
            {activeTab.index != 0 && (
              <PrimaryButton
                onClick={() => {
                  clearAll();
                  setActiveTab((prev) => ({
                    ...activeTab,
                    showForm: !prev.showForm,
                    isEditId: null,
                  }));
                }}
              >
                <Icon className="text-lg mr-3" icon="fluent:add-48-filled" />
                {activeTab?.showForm ? "Show All" : "Create New"}
              </PrimaryButton>
            )}
          </div>
        </div>
        <Tabs
          colorScheme="teal"
          index={activeTab.index}
          onChange={handleTabChange}
        >
          <TabList>
            {menuItems.map((item, index) => (
              <>{item.isVisible && <Tab key={index}>{item.name}</Tab>}</>
            ))}
          </TabList>

          <TabPanels
            pointerEvents={isDuplicating ? "none" : "auto"}
            opacity={isDuplicating ? 0.7 : 1}
          >
            <TabPanel>
              <SiteFeasibility
                duplicatePresentation={duplicatePresentation}
                activeTab={activeTab}
                data={presentationData?.feasibility}
                setActiveTab={setActiveTab}
                isRandom={isRandom}
                handlePublicLink={handlePublicLink}
                handleClose={handleClose}
                fetchPresentationData={(id) =>
                  setPresentationData((prev) => ({
                    ...prev,
                    feasibility: prev?.feasibility?.filter(
                      (v) => v?._id !== id,
                    ),
                  }))
                }
              />
            </TabPanel>
            <TabPanel>
              <ConcepMoodBoardForm
                activeTab={activeTab}
                data={presentationData?.concept}
                setActiveTab={setActiveTab}
                handlePublicLink={handlePublicLink}
                handleClose={handleClose}
                isRandom={isRandom}
                fetchPresentationData={(id) =>
                  setPresentationData((prev) => ({
                    ...prev,
                    concept: prev?.concept?.filter((v) => v?._id !== id),
                  }))
                }
                duplicatePresentation={duplicatePresentation}
              />
            </TabPanel>
            (
            <TabPanel>
              <ThreeDRender
                activeTab={activeTab}
                data={presentationData?.render}
                setActiveTab={setActiveTab}
                handlePublicLink={handlePublicLink}
                handleClose={handleClose}
                isRandom={isRandom}
                fetchPresentationData={(id) =>
                  setPresentationData((prev) => ({
                    ...prev,
                    render: prev?.render?.filter((v) => v?._id !== id),
                  }))
                }
                duplicatePresentation={duplicatePresentation}
              />
            </TabPanel>
            )
          </TabPanels>
        </Tabs>

        {/* Public View Modal */}
        {/* <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color="teal.600">Public View Link</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <InputGroup>
                <Input
                  value={publicLink}
                  isReadOnly
                  placeholder="Public link will appear here..."
                  bg="gray.50"
                  border="1px"
                  borderColor="teal.200"
                  _focus={{
                    borderColor: "teal.400",
                    boxShadow: "0 0 0 1px teal.400",
                  }}
                />
                <InputRightElement>
                  <IconButton
                    aria-label="Copy link"
                    icon={<Icon icon="mdi:content-copy" />}
                    size="sm"
                    colorScheme="teal"
                    variant="ghost"
                    onClick={copyToClipboard}
                    isDisabled={!publicLink}
                  />
                </InputRightElement>
              </InputGroup>
            </ModalBody>
            <ModalFooter gap={3}>
              <Button
                variant="outline"
                colorScheme="teal"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                colorScheme="teal"
                onClick={openPublicView}
                isDisabled={!publicLink}
              >
                Open Public View
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal> */}
        <SharePopup
          isOpen={isOpen}
          handleClose={handleClose}
          publicLink={encodeURI(publicLink)}
        />
      </div>
    </Layout>
  ) : (
    <div className="mx-auto container p-3">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          {activeTab.showForm && (
            <IconButton
              onClick={() => {
                clearAll();
                setActiveTab((prev) => ({
                  ...activeTab,
                  showForm: !prev.showForm,
                  isEditId: null,
                }));
              }}
              colorScheme="gray"
              size={"sm"}
              icon={<Icon icon={"ion:arrow-back"} color="black" />}
            />
          )}
          <h2 className="text-xl font-bold">{projectData?.title}</h2>
        </div>
        <div className="flex gap-3">
          {/* <Button className="bg-primary-500 text-white rounded-lg p-3 text-sm flex gap-1 items-center">
            <Icon className="text-lg" icon="fluent:add-48-filled" /> Create New
          </Button> */}
          {activeTab.index != 0 && (
            <PrimaryButton
              onClick={() => {
                console.log("FORM CONTEXT", clearAll);
                clearAll();

                setActiveTab((prev) => ({
                  ...activeTab,
                  showForm: !prev.showForm,
                  isEditId: null,
                }));
              }}
            >
              <Icon className="text-lg mr-3" icon="fluent:add-48-filled" />
              {activeTab?.showForm ? "Show All" : "Create New"}
            </PrimaryButton>
          )}
        </div>
      </div>
      <Tabs
        colorScheme="teal"
        index={activeTab.index}
        onChange={handleTabChange}
      >
        <TabList>
          {menuItems.map((item, index) => (
            <Tab key={index}>{item.name}</Tab>
          ))}
        </TabList>

        <TabPanels
          pointerEvents={isDuplicating ? "none" : "auto"}
          opacity={isDuplicating ? 0.7 : 1}
        >
          <TabPanel>
            <SiteFeasibility
              duplicatePresentation={duplicatePresentation}
              activeTab={activeTab}
              data={presentationData?.feasibility}
              setActiveTab={setActiveTab}
              handlePublicLink={handlePublicLink}
              handleClose={handleClose}
              fetchPresentationData={(id) =>
                setPresentationData((prev) => ({
                  ...prev,
                  feasibility: prev?.feasibility?.filter((v) => v?._id !== id),
                }))
              }
            />
          </TabPanel>
          <TabPanel>
            <ConcepMoodBoardForm
              duplicatePresentation={duplicatePresentation}
              activeTab={activeTab}
              data={presentationData?.concept}
              handlePublicLink={handlePublicLink}
              handleClose={handleClose}
              setActiveTab={setActiveTab}
              fetchPresentationData={(id) =>
                setPresentationData((prev) => ({
                  ...prev,
                  concept: prev?.concept?.filter((v) => v?._id !== id),
                }))
              }
            />
          </TabPanel>
          <TabPanel>
            <ThreeDRender
              duplicatePresentation={duplicatePresentation}
              activeTab={activeTab}
              data={presentationData?.rendered}
              handlePublicLink={handlePublicLink}
              handleClose={handleClose}
              setActiveTab={setActiveTab}
              fetchPresentationData={(id) =>
                setPresentationData((prev) => ({
                  ...prev,
                  rendered: prev?.rendered?.filter((v) => v?._id !== id),
                }))
              }
            />
          </TabPanel>
        </TabPanels>
      </Tabs>

      {/* Public View Modal */}
      {/* <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="teal.600">Public View Link</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <InputGroup>
              <Input
                value={publicLink}
                isReadOnly
                placeholder="Public link will appear here..."
                bg="gray.50"
                border="1px"
                borderColor="teal.200"
                _focus={{
                  borderColor: "teal.400",
                  boxShadow: "0 0 0 1px teal.400",
                }}
              />
              <InputRightElement>
                <IconButton
                  aria-label="Copy link"
                  icon={<Icon icon="mdi:content-copy" />}
                  size="sm"
                  colorScheme="teal"
                  variant="ghost"
                  onClick={copyToClipboard}
                  isDisabled={!publicLink}
                />
              </InputRightElement>
            </InputGroup>
          </ModalBody>
          <ModalFooter gap={3}>
            <Button variant="outline" colorScheme="teal" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              colorScheme="teal"
              onClick={openPublicView}
              isDisabled={!publicLink}
            >
              Open Public View
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}
      <SharePopup
        isOpen={isOpen}
        handleClose={handleClose}
        publicLink={encodeURI(publicLink)}
      />
    </div>
  );
}

export const SharePopup = ({ isOpen, handleClose, publicLink }) => {
  const toast = useToast();
  const pId = publicLink.split("/")[publicLink.split("/").length - 2];
  publicLink = publicLink.replace(pId, "1");
  const companyName = decodeURIComponent(publicLink)
    .split("/")
    ?.[publicLink.split("/").length - 1]?.split("?")[0];
  let type =
    decodeURIComponent(publicLink).split("/")?.[
      publicLink.split("/").length - 3
    ];
  const TYPE = {
    site: "site feasibility",
    render: "3D Render",
    concept: "conceptual moodboard",
    conceptual: "conceptual moodboard",
  };
  if (publicLink.includes("/site")) {
    publicLink = publicLink.replace("/site", "/sf");
  }
  if (publicLink.includes("/conceptual")) {
    publicLink = publicLink.replace("/conceptual", "/cm");
  }
  if (publicLink.includes("/render")) {
    publicLink = publicLink.replace("/render", "/tr");
  }
  //   if (publicLink.includes("/rendered")) {
  //   publicLink = publicLink.replace("/rendered", "/tr");
  // }
  if (type == "cm") type = "conceptual";
  if (type == "tr") type = "render";
  // console.log("PUBLIC LINK",publicLink, decodeURIComponent(publicLink), type, TYPE[type]);
  type = TYPE[type];
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(publicLink);
      toast({
        title: "Link copied!",
        description: "The public link has been copied to your clipboard.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: "Failed to copy",
        description: "Could not copy the link to clipboard.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };
  const openPublicView = async () => {
    if (publicLink) {
      // console.log(data);
      // return;
      window.open(publicLink);
    }
  };
  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`AirBrick x ${companyName} \nCheck out this ${type} presentation by AirBrick\n${publicLink}`)}`;
    window.open(whatsappUrl, "_blank");
  };
  const handleEmailShare = () => {
    const emailUrl = `mailto:?subject=${encodeURIComponent(`AirBrick x ${companyName}`)}&body=${encodeURIComponent(`${`Check out this ${type} presentation by AirBrick`}\n\n${publicLink}`)}`;
    window.location.href = emailUrl;
  };
  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="teal.600">Public View Link</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <InputGroup>
            <Input
              value={publicLink}
              isReadOnly
              placeholder="Public link will appear here..."
              bg="gray.50"
              border="1px"
              borderColor="teal.200"
              _focus={{
                borderColor: "teal.400",
                boxShadow: "0 0 0 1px teal.400",
              }}
            />
            <InputRightElement>
              <IconButton
                aria-label="Copy link"
                icon={<Icon icon="mdi:content-copy" />}
                size="sm"
                colorScheme="teal"
                variant="ghost"
                onClick={copyToClipboard}
                isDisabled={!publicLink}
              />
            </InputRightElement>
          </InputGroup>
          <p className="text-gray-600 text-sm  mt-1">Link valid for 6 hours</p>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <Button
              leftIcon={<Icon icon="mdi:whatsapp" color="#25D366" />}
              colorScheme="green"
              variant="ghost"
              size={"sm"}
              onClick={handleWhatsAppShare}
              isDisabled={!publicLink}
            >
              Share on WhatsApp
            </Button>
            <Button
              leftIcon={<Icon icon="mdi:email" color="#3182CE" />}
              colorScheme="blue"
              variant="ghost"
              size={"sm"}
              onClick={handleEmailShare}
              isDisabled={!publicLink}
            >
              Share via Email
            </Button>
          </div>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="outline" colorScheme="teal" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            colorScheme="teal"
            onClick={openPublicView}
            isDisabled={!publicLink}
          >
            Open Public View
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Presentation;
